module.exports = __webpack_public_path__ + "img/arrowLeftWhite.6014f588.svg";